//#region IMPORT
import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  CircularProgress,
  Stack,
  styled,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@mui/material';
import {
  Group as GroupIcon,
  QrCodeScanner as QrCodeScannerIcon,
} from '@mui/icons-material';
import { Button, Dialog } from '../../../Components/MUIs';
import Commons from '../../../Services/Common/Common';
import QrCreator from '../../../Components/QR-Code/QR-Creator/QrCreator';
import UserInfoCard from '../../../Components/Ui/UserInfoCard';
import dayjs from 'dayjs';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import { useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
//#endregion

//#region 커스텀 디자인 컴포넌트
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 78,
    width: '100%',
    backgroundColor: '#65558F',
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(16),
    marginRight: theme.spacing(1),
    color: '#000',
    '&.Mui-selected': {
      color: '#65558F',
    },
    // '&.Mui-focusVisible': {
    //   backgroundColor: '#d1eaff',
    // },
  })
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      {/* 프로그레스 바 */}
      <CircularProgress
        variant="determinate"
        value={props.percentage}
        thickness={3}
        size={160}
        sx={{
          color: '#FFC2CD',
          zIndex: 1,
        }}
      />

      {/* 회색 배경 (미이수 부분) 뒤에 오버레이되게끔 둠 */}
      <CircularProgress
        variant="determinate"
        value={100}
        thickness={3}
        size={160}
        sx={{
          color: '#F0F2F3',
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 0,
        }}
      />

      {/* 흰색 내경 배경 */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 115, // 내부 흰색 원의 크기 조절
          height: 115,
          backgroundColor: '#fff',
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // 그림자 추가
        }}
      />

      {/* 중앙 텍스트 및 설명 */}
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        right={0}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
      >
        <Typography sx={{ fontSize: '28px' }} fontWeight="bold">
          {`${props.percentage}`}
          <span
            style={{ color: '#828282', fontSize: '18px', fontWeight: 'bold' }}
          >
            %
          </span>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Typography variant="caption">
            <span style={{ color: '#FFC2CD', fontWeight: 'bold' }}>●</span> 이수
            시간
          </Typography>
          <Typography variant="caption">
            <span style={{ color: '#F0F2F3', fontWeight: 'bold' }}>●</span>{' '}
            미이수 시간
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
//#endregion

function M_TBG_BASIC_02(props) {
  const { ToggleDrawer } = useOutletContext();
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  return (
    <>
      <Box sx={{ px: 2 }}>
        <UserInfoCard
          progress={{ current: props.current, duration: props.duration }}
          profileImg={
            props.rowData.filter(
              (f) => f.ID === Commons.DecryptoAES(props.userInfo.userid)
            )[0]?.PROFILE
              ? props.rowData.filter(
                  (f) => f.ID === Commons.DecryptoAES(props.userInfo.userid)
                )[0]?.PROFILE
              : ''
          }
          userInfo={props.userInfo}
          showConstruction={false}
          showProgress={false}
          showDayProgress={true}
          onClick={(e) => {
            props.SearchGj();
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'profileDrawer',
              })
            );
          }}
        />
      </Box>
      <Box>
        <StyledTabs
          value={props.value}
          onChange={props.HandleChange}
          variant="fullWidth"
          sx={{
            my: '16px',
            backgroundColor: '#fff',
            borderBottom: 1,
            borderColor: '#F3F4F6',
          }}
        >
          <StyledTab label="참여자 목록" {...A11yProps(0)} />
          <StyledTab label="교육 목록" {...A11yProps(1)} />
        </StyledTabs>
        <CustomTabPanel value={props.value} index={0}>
          <Box sx={{ px: '16px' }}>
            <TableContainer
              sx={{
                border: 1,
                borderColor: '#F3F4F6',
                borderRadius: 4,
              }}
            >
              <Table>
                <colgroup>
                  <col style={{ width: '60%' }} />
                  <col style={{ width: '40%' }} />
                </colgroup>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#fff' }}>
                    <TableCell sx={{ px: 3, py: 1.5, borderBottom: 'none' }}>
                      <Typography sx={{ fontSize: '14px' }} fontWeight="bold">
                        참여자
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ px: 3, py: 1.5, borderBottom: 'none' }}
                    >
                      <Typography sx={{ fontSize: '14px' }} fontWeight="bold">
                        교육 이수
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.rowData.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: props.check.find(
                          (check) =>
                            check.type === 'check1' &&
                            Commons.DecryptoAES(check.id) === item.ID
                        )?.content
                          ? '#d9f2d9'
                          : '#fddede',
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ px: 3, py: 0.5, borderBottom: 'none' }}
                      >
                        <Box display="flex" alignItems="center" gap={2}>
                          {item.PROFILE ? (
                            <Avatar src={item.PROFILE} />
                          ) : (
                            <Avatar></Avatar>
                          )}
                          <Typography>{item.NAME}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ px: 3, py: 0.5, borderBottom: 'none' }}
                      >
                        <Typography
                          fontWeight="bold"
                          color={
                            props.check.find(
                              (check) =>
                                check.type === 'check1' &&
                                Commons.DecryptoAES(check.id) === item.ID
                            )?.content
                              ? '#2CA900'
                              : '#FF0000'
                          }
                        >
                          {props.check.find(
                            (check) =>
                              check.type === 'check1' &&
                              Commons.DecryptoAES(check.id) === item.ID
                          )?.content
                            ? '완료'
                            : '미완료'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  p: 1.5,
                  px: 3,
                  backgroundColor: '#fff',
                }}
              >
                <GroupIcon />
                <Typography>
                  전체 {props.rowData.length}명 중{' '}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {
                      props.check.filter((item) => item.type === 'check1')
                        .length
                    }
                    명
                  </Typography>{' '}
                  교육 완료
                </Typography>
              </Box>
            </TableContainer>
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={props.value} index={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: 4,
              m: 2,
              p: 2,
              border: 1,
              borderColor: '#F3F4F6',
            }}
          >
            <Typography fontWeight="bold" mb={2}>
              {dayjs().format('MMMM')} 교육 시간
            </Typography>

            <Box mb={2} display="flex" justifyContent="center">
              <CircularProgressWithLabel
                percentage={Math.min(
                  100,
                  Math.round((props.completed / 12000) * 100)
                )}
              />
            </Box>

            <Typography fontSize="14px" mb={0.5}>
              총{' '}
              <span style={{ color: '#00789E', fontWeight: 'bold' }}>
                {props.total}
              </span>
              분 중{' '}
              <span style={{ color: '#FFB3C0', fontWeight: 'bold' }}>
                {Math.floor(props.completed / 60)}
              </span>
              분 이수 완료하였습니다.
            </Typography>
            <Typography fontSize="14px">
              {dayjs().format('MMMM')} TBM 이수까지{' '}
              <span style={{ fontWeight: 'bold' }}>
                {Math.max(0, props.total - Math.floor(props.completed / 60))}
              </span>
              분 남았습니다.
            </Typography>
          </Box>
        </CustomTabPanel>
        <Stack
          sx={{
            m: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
          }}
          direction={'row'}
          spacing={3}
        >
          <Button
            variant="outlined"
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
              px: 0,
              border: 2,
              '&:hover': {
                border: 2,
              },
            }}
            name={
              <>
                <QrCodeScannerIcon sx={{ color: 'black' }} />
                <Typography sx={{ fontSize: '14px', color: '#575757' }}>
                  QR 코드
                </Typography>
              </>
            }
            onClick={() => {
              props.SearchLogic2();
              props.setModalToggle1(true);
            }}
          />
          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name="확인"
            onClick={() => {
              props.ActiveButton({
                type: 'next',
                content: true,
                step: 2, // 근로자 기준
              });
              props.setActiveStep(props.activeStep + 1);
              props.SaveLogic1(2, 2);
            }}
          />
        </Stack>
      </Box>
      {/* 프로필 바텀 드로워 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'profileDrawer' && (
        <BottomSheet
          open={true}
          onClose={ToggleDrawer('bottom', false)}
          onOpen={ToggleDrawer('bottom', true)}
          isHeaderChildren={true}
          headerText={''}
          headerChildren={
            <Typography
              sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
            >
              사용자 정보
            </Typography>
          }
        >
          <Box sx={{ p: '8px' }}>
            <Box sx={{ mb: 4 }}>
              <UserInfoCard
                profileImg={
                  props.rowData.filter(
                    (f) => f.ID === Commons.DecryptoAES(props.userInfo.userid)
                  )[0]?.PROFILE
                    ? props.rowData.filter(
                        (f) =>
                          f.ID === Commons.DecryptoAES(props.userInfo.userid)
                      )[0]?.PROFILE
                    : ''
                }
                userInfo={props.userInfo}
                gjList={props.gjList}
                showProgress={false}
                showButton={false}
                cardSx={{ p: 0, border: 0 }}
              />
            </Box>
            <Button
              sx={{
                width: '100%',
                height: '36px',
                borderRadius: '18px',
              }}
              name="확인"
              onClick={ToggleDrawer('bottom', false)}
            />
          </Box>
        </BottomSheet>
      )}
      {/* qr 코드 모달 */}
      {props.modalToggle1 && (
        <Dialog
          title="교육 입장을 위한 QR 코드"
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{ fontSize: '18px', fontWeight: 'bold', pt: 3 }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName={'선택'}
          closeButtonName={'닫기'}
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {}}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <QrCreator value={props.qrcode} />
              <Box
                sx={{
                  p: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 전체 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.userCount}명
                  </Typography>{' '}
                  참여 중
                </Typography>
              </Box>
              <Button
                sx={{
                  width: '100%',
                  height: '36px',
                  borderRadius: '18px',
                }}
                name="확인"
                onClick={() => {
                  props.setModalToggle1(false);
                }}
              />
            </Box>
          }
        />
      )}
    </>
  );
}

export default M_TBG_BASIC_02;
